import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ManualKpiResolution, ManualKpiToUpdate} from '../types'

import {ManualKpisQueryKey} from './useManualKpis'

type UseUpdateKpisParams = {
  plantId: string
  resolution: ManualKpiResolution
  timestamp: Iso8601
  options?: UseMutationOptions<never, AxiosError, ManualKpiToUpdate[]>
}

export const useUpdateKpis = ({plantId, resolution, timestamp, options}: UseUpdateKpisParams) => {
  const queryClient = useQueryClient()
  const path = `/shifthandover/${plantId}/kpi/${resolution}/${timestamp}`

  return useMutation<never, AxiosError, ManualKpiToUpdate[]>({
    mutationFn: async (kpis) => {
      const response = await ApiClient.axiosInstance.put<never>(path, kpis)
      return response.data
    },
    ...options,
    onSuccess: (data, variables, context, mutation) => {
      void options?.onSuccess?.(data, variables, context, mutation)
      void queryClient.invalidateQueries({queryKey: [ManualKpisQueryKey]})
    }
  })
}
